import { useAuth } from "@clerk/nextjs";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { UserPermission } from "~/lib/drizzle/type";
import { apiBaseUrl, fetchWrapper } from "~/utils/utils";

export const useGetUserPermissions = (): UseQueryResult<UserPermission[]> => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: ['userPermissions'],
    queryFn: async () => {
      const token = await getToken();
      return fetchWrapper({
        url: `${apiBaseUrl}/user-permissions/me`,
        method: 'GET',
        token,
      })
    },
    staleTime: 5_000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}